import { useContext } from 'react';
import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { usePageMeta } from 'shared/mechanics/page-meta';
import { prerenderMarkLoaded } from 'shared/mechanics/prerender';
import { decodeSiteResolutionFunc, SiteResolutionContext } from 'shared/mechanics/site-resolution';

import { PageCompactComponent, PageDesktopComponent } from './components/PageComponent';

export const MapStructurePage = () => {
	usePageMeta({
		title: 'Карта БПИФ и ETF на МосБирже',
		description: 'Найти нужный фонд просто! Классификация фондов по классам и странам',
		keyWords: ['таблица', 'признаки', 'регион', 'география'],
		canonicalPath: 'map/structure' });

	prerenderMarkLoaded();

	return (
		<SiteLayoutComponent activeSection={SiteSection.Map}>
			<MapStructureCoreComponent />
		</SiteLayoutComponent>
	);
}

const MapStructureCoreComponent = () => {
	const siteResolution = useContext(SiteResolutionContext);

	const pageComponent = decodeSiteResolutionFunc(
		siteResolution,
		() => <PageDesktopComponent />,
		() => <PageCompactComponent />)

	return pageComponent;
}